import { render, staticRenderFns } from "./CustomRequestListView.vue?vue&type=template&id=6d385240&scoped=true"
import script from "./CustomRequestListView.vue?vue&type=script&lang=js"
export * from "./CustomRequestListView.vue?vue&type=script&lang=js"
import style0 from "./CustomRequestListView.vue?vue&type=style&index=0&id=6d385240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d385240",
  null
  
)

export default component.exports